module.exports = __webpack_public_path__ + "static/media/mentor.e2959ddc.png";